export default __webpack_public_path__ + "assets/slide-2.50a246ae.png";